import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { TextField, Grid, makeStyles, CircularProgress, Button } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SelecaoEmpresaService from '../services/SelecaoEmpresaService';
import { MenuEnum } from '../enums';
import { cnpjMask, removeMask } from '../utils';
import { resetarStateFaturamento } from '../redux/actions/FaturamentoAction';
import { resetarStatePedido } from '../redux/actions/PedidoAction';

const useStyles = makeStyles(theme => ({
    gridHeader: {
        height: 70,
        backgroundColor: theme.palette.primary.main
    },
    gridBody: {
        marginTop: 30
    },
    autoComplete: {
        width: 300
    },
    grid_autocomplete: {
        marginTop: 25,
        marginBottom: 10
    },
    btn_ok: {
        color: theme.palette.primary.contrastText
    }
}));

function AutoCompleteEmpresa(
    {
        history,
        handleError,

        resetarStateFaturamento,
        resetarStatePedido
    }
) {
    const classes = useStyles();
    const [listaEmpresa, setListaEmpresa] = useState([]);
    const [cusNum, setCusNum] = useState(null);
    const [loading, setLoading] = useState(null);

    const handleBuscarEmpresa = (event, value) => {
        const { type } = event.target;
        value = removeMask(value).trim();

        if (type === 'text') {
            setCusNum(null);
            if (value.length >= 3) {
                setLoading(true);
                SelecaoEmpresaService.obterListagemEmpresaAutocomplete(value)
                    .then((response) => {
                        setLoading(false);
                        var data = response.data;
                        data.forEach(item => {
                            item.cnpjFormatado = cnpjMask(item.cnpjEmpresa);
                        });
                        setListaEmpresa(data);
                    }).catch((error) => {
                        setLoading(false);
                        handleError(error);
                    });
            } else {
                setLoading(false);
                setListaEmpresa([]);
            }
        }
    }

    const handleSelecionarEmpresa = (event, value) => {
        const ud = JSON.parse(localStorage.getItem('user_data'));

        if (value) {
            ud.codigoEmpresa = value.codigoEmpresa;
            ud.razaoSocial = value.razaoSocial;

            setCusNum(value.codigoEmpresa);
        } else {
            setCusNum(null);
        }

        localStorage.setItem('user_data', JSON.stringify(ud));
    }

    const handleOk = () => {
        resetarStateFaturamento();
        resetarStatePedido();
        history.push(MenuEnum.properties[MenuEnum.HOME].path);
    }

    return (
        <Grid container
            direction="column"
            alignItems="center"
            justify="center">
            <Grid item
                className={classes.grid_autocomplete}>
                <Autocomplete
                    options={listaEmpresa}
                    autoComplete
                    freeSolo
                    getOptionLabel={option => option.razaoSocial}
                    className={classes.autoComplete}
                    disableOpenOnFocus
                    onInputChange={handleBuscarEmpresa}
                    onChange={handleSelecionarEmpresa}
                    renderInput={
                        (params) => (
                            <TextField {...params}
                                label="Razão Social ou CNPJ"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading === true && <CircularProgress color='secondary' size={20} />}
                                            {params.InputProps.endAdornment}
                                        </>
                                    )
                                }}
                            />
                        )}
                    renderOption={
                        (option) => (
                            <Grid container
                                direction="column">
                                <Grid item>
                                    {option.razaoSocial}
                                </Grid>
                                <Grid item>
                                    {cnpjMask(option.cnpjEmpresa)}
                                </Grid>
                            </Grid>
                        )
                    }
                />
            </Grid>
            <Grid item>
                <Button variant="contained"
                    color="primary"
                    className={classes.btn_ok}
                    disabled={cusNum === null}
                    onClick={handleOk}>
                    Ok
                </Button>
            </Grid>
        </Grid>
    );
}

const mapDispatchToProps = {
    resetarStateFaturamento,
    resetarStatePedido
}

export default connect(null, mapDispatchToProps)(withRouter(AutoCompleteEmpresa));